import i18next from "i18next";
import Select from "react-select";
import FieldTitle from "./FieldTitle";
import useDebouncedFunction from "../hooks/useDebouncedFunction";
import { constants } from "../utils";

interface AutocompleteProps {
	onInputChange?: (e: any) => void;
	datatestid?: string | undefined;
	defaultValue?: any;
	id?: string | undefined;
	placeholder?: string | undefined;
	label?: string | null;
	className?: string;
	error?: string | null;
	showValue?: boolean;
	renderValue?: (value: any) => JSX.Element | null;
	options: any[];
	onChange?: (value: any) => void;
	value?: any;
	theme?: any;
	loading?: boolean;
	required?: boolean;
}

const MultiSelect = ({
	className,
	label,
	showValue,
	error,
	placeholder,
	datatestid,
	options,
	renderValue = (value) => (value ? <div>{value?.map(({ name }) => name).join(", ")}</div> : null),
	onChange,
	onInputChange,
	value,
	loading,
	required,
}: AutocompleteProps) => {
	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderColor: error ? "red" : provided.borderColor,
			"&:hover": {
				borderColor: error ? "red" : provided["&:hover"].borderColor,
			},
			boxShadow: state.isFocused ? (error ? "0 0 0 1px red" : provided.boxShadow) : provided.boxShadow,
		}),
	};

	const debouncedSearch = useDebouncedFunction((value) => {
		onInputChange?.({ target: { value, id: "gender" } });
	}, constants.DEBOUNCE_TIME);

	return (
		<div className={className}>
			<FieldTitle label={label} required={required} />
			{!showValue && (
				<>
					<Select
						options={options}
						isMulti
						value={value}
						inputId={datatestid}
						onInputChange={(e) => debouncedSearch(e)}
						noOptionsMessage={() => i18next.t("no-results")}
						loadingMessage={() => i18next.t("searching")}
						isLoading={loading}
						styles={customStyles}
						onChange={onChange}
						isSearchable={true}
						placeholder={placeholder}
					/>
				</>
			)}
			{showValue && value && renderValue(value)}
			{showValue && !value && <div>{i18next.t("no-value")}</div>}
		</div>
	);
};

export default MultiSelect;
